import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/terms-conditon-content/terms-conditon-content.tsx");
